module.exports = __webpack_public_path__ + "fdbe428779e02446e1b95544cc4a0600.svg";